import { QueryClient, useQuery } from 'vue-query'
import QueryKeys from '@/vue-query/QueryKeys'
import { useSubscriptionApi } from '@/api/Subscription'

export function useSubscriptionQuery() {
  const client = useSubscriptionApi()
  return useQuery({
    queryKey: [QueryKeys.Subscription],
    queryFn: () => client.getUserSubscription(),
  })
}

export function useSubscriptionQueryPrefetch(
  queryClient: QueryClient,
): Promise<void> {
  const client = useSubscriptionApi()
  return queryClient.prefetchQuery({
    queryKey: [QueryKeys.Subscription],
    queryFn: () => client.getUserSubscription(),
  })
}
